import { render, staticRenderFns } from "./addBusiness.vue?vue&type=template&id=1cb043a6&scoped=true"
import script from "./addBusiness.vue?vue&type=script&lang=js"
export * from "./addBusiness.vue?vue&type=script&lang=js"
import style0 from "./addBusiness.vue?vue&type=style&index=0&id=1cb043a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb043a6",
  null
  
)

export default component.exports